export function selectActiveResult(rows) {
  if (!Array.isArray(rows)) return null;

  const isRealResult = (row) => row && row.username !== "no";
  const hasMajor = (row, major) => Number(row.major) === major;
  const historicalResults = rows.filter(isRealResult);

  return (
    rows.find((row) => isRealResult(row) && hasMajor(row, 1)) ||
    rows.find((row) => isRealResult(row) && hasMajor(row, 2)) ||
    historicalResults[historicalResults.length - 1] ||
    null
  );
}

export function getResultStep(result) {
  if (!result || result.bidderaccept !== "Yes") return 0;
  if (result.proaccept !== "Yes" || result.payment !== "Yes") return 1;
  return 3;
}
